import { formatDateTimeT, t } from 'src/lib/player/i18n';
import { useStore } from 'src/lib/player/store';
import { NBSP } from 'src/lib/player/utils';

const CDN_HOST = import.meta.env.VITE_CDN_HOST;

export default function InfoSection(): JSX.Element {
  const currentEvent = useStore((state) => state.events[state.currentEventIndices[0]]);

  return (
    <div className="info-section">
      <div className="event-logo">
        <img src={`${CDN_HOST}/api/events/${currentEvent.eventId}/logo`} alt="Logo" />
      </div>
      <div className="event-info">
        <p className="event-name">{currentEvent.name}</p>
        <p>
          {formatDateTimeT(currentEvent.startTime)}&nbsp;–&nbsp;
          {formatDateTimeT(currentEvent.endTime)}
        </p>
        <p>
          {currentEvent.eventLocation}&nbsp;&bull;&nbsp;{currentEvent.starters.length}&nbsp;
          {t('info.athletes')}
        </p>
        {currentEvent.eventDescription !== '' && (
          <p style={{ maxWidth: 600 }}>{currentEvent.eventDescription}</p>
        )}
        {(currentEvent.eventWebsite !== '' || currentEvent.eventContactMail !== '') && (
          <p>
            {currentEvent.eventWebsite !== '' && (
              <a
                href={currentEvent.eventWebsite}
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                Website
              </a>
            )}
            {currentEvent.eventWebsite !== '' &&
              currentEvent.eventContactMail !== '' &&
              `${NBSP}${NBSP}`}
            {currentEvent.eventContactMail !== '' && (
              <a
                href={`mailto:${currentEvent.eventContactMail}`}
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                Email
              </a>
            )}
          </p>
        )}
      </div>
    </div>
  );
}
